











































import { Component, Vue, Emit } from "vue-property-decorator";
import LoginArea from "./login/LoginArea.vue";
import DoubleLoginArea from "./login/DoubleLoginArea.vue";
import DeviceGateArea from "./login/DeviceGateArea.vue";
import LoginTitle from "@/components/app/login/LoginTitle.vue";

@Component({
  components: {
    LoginArea,
    DoubleLoginArea,
    DeviceGateArea,
    LoginTitle
  }
})
export default class Login extends Vue {
  /** パスワードリセット処理 */
  @Emit() private passwordReset() {
    return;
  }

  /** ログイン終了 */
  @Emit() private login(isOpenRegistDialog = false) {
    return isOpenRegistDialog;
  }

  /** 2段階認証フラグ */
  private isDoubleLogin = false;

  /** 端末制限：ログインゲート（WebAuthn）画面フラグ */
  private isDeviceGate = false;

  /** 端末制限：ゲートに引き継ぐトークン・モード・許可端末数 */
  private gateToken = "";
  private gateMode = 0;
  private gateCount = 0;

  /** EweLLUserID */
  private ewellUserId = 0;

  /** 通常ログインフォーム表示かどうか */
  private get isNormalLogin(): boolean {
    return !this.isDoubleLogin && !this.isDeviceGate;
  }

  /** ログアウト後のログイン画面かどうか */
  private get wasLogout(): boolean {
    return this.$route.query.action === "logout";
  }

  private get IframeSrc(): string {
    return (
      "https://infomationauth.ibowservice.jp/?time=" + new Date().getTime()
    );
  }

  /** ログイン終了 */
  private finishLogin(isOpenRegistDialog = false) {
    if (this.$route.query.return_url) {
      location.href = this.$route.query.return_url as string;
    } else {
      this.login(isOpenRegistDialog);
    }
  }

  /** 2段階認証 */
  private continuedLogin(ewellUserId: number) {
    this.ewellUserId = ewellUserId;
    this.isDoubleLogin = true;
  }

  /** 端末制限：ログインゲート画面へ */
  private startDeviceGate(payload: {
    token: string;
    ewellUserId: number;
    mode: number;
    count: number;
  }) {
    this.gateToken = payload.token;
    this.ewellUserId = payload.ewellUserId;
    this.gateMode = payload.mode;
    this.gateCount = payload.count;
    this.isDeviceGate = true;
  }

  /** 通常ログイン画面に戻す */
  private resetToLogin() {
    this.isDeviceGate = false;
    this.gateToken = "";
    this.gateMode = 0;
    this.gateCount = 0;
  }
}
